import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import { vegetablesFull } from 'components/ProductItems/mockData';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import banerImage from 'images/trial-results-banner.jpg';
import { CTAFormSection } from 'components/formSections/CTAFormSection';
import { trialResults } from 'components/Filter/mockData';

const TrialResults = () => {
    const data = [...vegetablesFull].reverse();

    return (
        <div className="container">
            <Banner title="Trial results" image={banerImage} buttonText="View results" />
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>agricultural solutions</LabelButton>
                    <GradientText>
                        We showcase the results <br /> of our <img src={image} alt="decor" />
                        <em>research on different groups of plants</em>
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="super-small">
                            Here you can find <em>analyzes and conclusions</em> on the effectiveness of products in
                            increasing yields.
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={trialResults} />}>
                    <div className="box">
                        <ProductItems data={data} />
                    </div>
                </WithSidebar>
            </div>
            <CTAFormSection />
        </div>
    );
};

export default TrialResults;
